import { service } from '../../../../helpers/http'

export const ActionTypeProcessIndex = ({ dispatch }, payload) => {
    return service({
        module: 'typeProcess',
        action: 'typeProcessIndex',
        payload: payload
    })
}

export const ActionTypeProcessStore = ({ dispatch }, payload) => {
    return service({
        module: 'typeProcess',
        action: 'typeProcessStore',
        payload: payload
    })
}

export const ActionTypeProcessUpdate = ({ dispatch }, payload) => {
    return service({
        module: 'typeProcess',
        action: 'typeProcessUpdate',
        payload: payload
    })
}

export const ActionTypeProcessDestroy = ({ dispatch }, payload) => {
    return service({
        module: 'typeProcess',
        action: 'typeProcessDestroy',
        payload: payload
    })
}